import { ArrowLeft } from 'lucide-react'
import React from 'react'
import { Link } from 'react-router-dom'
import { ReactComponent as NotFound } from 'assets/svg/not-found.svg';

const Notfound = () => {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center px-4 py-16">
    <div className="flex max-w-lg flex-col items-center gap-6 text-center">
      <div className="flex items-center justify-center rounded-full w-[100px] h-[100px]">
      <NotFound  />
      </div>
      <div className="flex flex-col gap-2">
        <h1 className=" md:text-7xl text-6xl font-bold text-blue-black text-center">
          404
        </h1>
        <h2 className=" md:text-2xl text-xl font-bold text-blue-black text-center">
          Page not found
        </h2>
        <p className="sm:text-xl text-base font-normal text-gray-2 sm:py-[18px] text-center">
          The page you're looking for doesn't exist or has been moved.
        </p>
      </div>
      <Link
        to="/"
        className="inline-flex items-center gap-2 rounded-full border border-primary bg-primary px-6 py-3 font-nunito
         text-base font-semibold text-white shadow-sm transition-all duration-300"
      >
        <ArrowLeft className="size-5" strokeWidth={2} />
        Back to Home
      </Link>
    </div>
  </div>
  )
}

export default Notfound